import React, { useState, useCallback, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { authActions } from "../../../redux/actions/auth.action";
import { useDispatch, useSelector } from "react-redux";
import { Password } from "primereact/password";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Controller } from "react-hook-form";
import {
  fieldLengthConstants,
  roles,
  StorageKeys,
  translationConstants,
  viewPathConstants,
} from "../../../constants";
import useReCaptcha from "../../../shared/hooks/ReCaptchaV3";
import { getLocalStorageItem } from "../../../system";

const LoginForm = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleReCaptchaVerify = useReCaptcha();
  const isLoginFromRegForm = useSelector(
    (state) => state.LoginReducer.isLoginFromRegForm
  );
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const isReCaptchaValid = await handleReCaptchaVerify();
    if (!isReCaptchaValid) {
      return;
    }

    const userData = {
      email: data.email,
      password: data.password,
      keepMeSignedIn: data.keepMeSignedIn,
    };
    dispatch(authActions.login(userData, navigateToDashboard));
  };
  const navigateToDashboard = async () => {
    if (!isLoginFromRegForm) {
      navigate(viewPathConstants.DEFAULT_PATH);
    }
  };

  return (
    <Form className="pb-2" noValidate onSubmit={handleSubmit(onSubmit)}>
      <span className="loginPara">{t(translationConstants.login)}</span>
      <span className="welcomePara ">
        {t(translationConstants.welcomeBack)}
      </span>
      <Form.Group className="form-group">
        <Form.Label>{t(translationConstants.email)}:</Form.Label>
        <Form.Control
          {...register("email", {
            required: t(translationConstants.emailRequired),
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/i,
              message: t(translationConstants.invalidEmail),
            },
          })}
          id="email"
          type="email"
          maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
          placeholder={t(translationConstants.emailPlaceholder)}
        />
        {errors.email && <p className="errorText">{errors.email.message}</p>}
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label className="Form-labels">
          {t(translationConstants.password)}:
        </Form.Label>
        <Controller
          defaultValue={""}
          name="password"
          className="LoginPasswordEye"
          control={control}
          rules={{
            required: t(translationConstants.passwordRequired),
          }}
          render={({ field }) => (
            <Password {...field} toggleMask feedback={false} />
          )}
        />
        {errors.password && (
          <p className="errorText">{errors.password.message}</p>
        )}
      </Form.Group>
      <Form.Group
        className="d-flex justify-content-space-between  check-me-Form"
        controlId="formBasicCheckbox"
      >
        <Form.Check
          className="custom-checkbox custom-checkboxInput"
          type="checkbox"
          label={t(translationConstants.keepMeSignedIn)}
          {...register("keepMeSignedIn")}
        />
        <span
          onClick={() => {
            if (props.handleShowForgotPassword) {
              props.handleShowForgotPassword();
            } else {
              navigate(viewPathConstants.FORGOT_PASSWORD);
            }
          }}
          className="forgotPara"
        >
          {t(translationConstants.forgotPassword)}
        </span>
      </Form.Group>
      <Button className="Login-button w-50" type="submit">
        {t(translationConstants.loginButton)}
      </Button>
    </Form>
  );
};

export default LoginForm;
